import { ChevronRight } from 'lucide-react';

export default function SubPageHeader({ title, onBack }) {
  return (
    <div className="sticky top-0 z-10 bg-background border-b border-border px-4 py-3 flex items-center gap-3">
      <button onClick={onBack} className="p-1.5 rounded-xl hover:bg-muted transition-colors">
        <ChevronRight className="w-5 h-5" />
      </button>
      <h2 className="text-base font-bold text-foreground flex-1">{title}</h2>
    </div>
  );
}